import { render, staticRenderFns } from "./PremiumShowAllCards.vue?vue&type=template&id=6ac86d5e&scoped=true&"
import script from "./PremiumShowAllCards.vue?vue&type=script&lang=js&"
export * from "./PremiumShowAllCards.vue?vue&type=script&lang=js&"
import style0 from "./PremiumShowAllCards.vue?vue&type=style&index=0&id=6ac86d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac86d5e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardText, BCard, BCardGroup, BButton} from 'bootstrap-vue'
    installComponents(component, {BCardText, BCard, BCardGroup, BButton})
    

export default component.exports